import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  ...theme.layouts.stepGrid,

  yourCoverReviewContainer: {
    marginBottom: '3rem',
    maxWidth: '43rem',
    '& h3': {
      marginBottom: '2rem',
    },
  },
  yourCoverReviewInnerContainer: {
    border: `2px solid ${theme.palette.light[400]}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.common.white,
    padding: '2rem 3rem 2rem 3rem',
    width: '100%',
    '@media (max-width: 765px)': {
      padding: '1.5rem',
    },
  },
  heading: {
    marginBottom: '2rem',
    '@media (max-width: 550px)': {
      marginBottom: '1rem',
      fontSize: '1.125rem',
    },
  },
  px05: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
  },
  textRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  bottomHighlight: {
    color: theme.palette.common.black,
    padding: '0rem 3rem',
    backgroundColor: theme.palette.grey[100],
    border: `2px solid ${theme.palette.light[400]}`,
    borderTop: 0,
    '@media (max-width: 400px)': {
      padding: '0rem 2rem 0rem 1rem',
    },
  },
  textSizeSmall: {
    '@media (max-width: 400px)': {
      fontSize: '0.8rem',
    },
  },
}));
